import React, { useRef } from "react";
import { useRemoteComponents } from "./internal/use-remote-components.js";
export function createSideNavigationLoader({ Fallback }) {
    return function SideNavigationLoader(props) {
        const ref = useRef(null);
        const components = useRemoteComponents(ref, { SideNavigation: Fallback });
        return components.SideNavigation ? React.createElement(components.SideNavigation, { ...props }) : React.createElement("div", { ref: ref });
    };
}
